import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SuperAdminSideNavComponent } from '../../admin/components/super-admin-side-nav/super-admin-side-nav.component';
import { SuperAdminHeaderComponent } from '../../admin/components/super-admin-header/super-admin-header.component';

@Component({
  selector: 'app-super-admin-shell',
  standalone: true,
  imports: [RouterOutlet, SuperAdminSideNavComponent, SuperAdminHeaderComponent],
  templateUrl: './super-admin-shell.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './super-admin-shell.component.scss',
})
export class SuperAdminShellComponent {}
